import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button, Field } from "../../components/primitives";
import { carryFrom } from "./authUtils";

// Shape check only: catches typos before a Firebase round-trip; Firebase stays the real judge.
const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Mirrors screens/SignUpScreen.js handleSignIn (:356). */
export default function LoginCard() {
  const { signIn, orphanedAccountMessage, clearOrphanedAccountMessage } = useAuth();
  const returnState = carryFrom(useLocation().state);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [keep, setKeep] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!email.trim() || !password) {
      setError("Please enter your email and password.");
      return;
    }
    if (!EMAIL_SHAPE.test(email.trim())) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    clearOrphanedAccountMessage();
    setLoading(true);
    try {
      const res = await signIn(email.trim(), password, keep);
      if (!res.success) setError(res.error || "Failed to sign in.");
    } catch {
      setError("An error occurred during sign in. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 style={{ fontSize: 30, fontWeight: 800, letterSpacing: "-.6px" }}>Welcome back</h2>
      <p className="muted">Sign in with your UM email.</p>
      {orphanedAccountMessage && <div className="auth-note" role="alert">{orphanedAccountMessage}</div>}
      <form className="col" style={{ gap: 14 }} onSubmit={submit} noValidate>
        <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" autoFocus data-testid="signIn.email" />
        <Field label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="signIn.password" />
        <div className="row" style={{ justifyContent: "space-between" }}>
          <label className="row" style={{ gap: 8, fontWeight: 600, fontSize: 13 }}>
            <input type="checkbox" data-testid="signIn.keepSignedIn" checked={keep} onChange={(e) => setKeep(e.target.checked)} /> Keep me signed in
          </label>
          <Link className="link" to="/auth/forgot" state={returnState} data-testid="signIn.forgotPassword">Forgot password?</Link>
        </div>
        {error && <div className="err-text" role="alert">{error}</div>}
        <Button variant="pri" full type="submit" disabled={loading} data-testid="signIn.submit">{loading ? "Signing in…" : "Sign in"}</Button>
      </form>
      <p className="meta" style={{ textAlign: "center" }}>
        New to VibeLink? <Link className="link" to="/auth/signup" state={returnState} data-testid="signIn.createAccount">Create an account</Link>
      </p>
    </>
  );
}
